import { lazy, Suspense, useState, useCallback } from "react";
import { Routes, Route, Outlet, Navigate, useParams } from "react-router-dom";
import {
  AppLayout,
  CompassPanel,
  ErrorBoundary,
  ProtectedRoute,
  PermissionRoute,
} from "@joint/jerry/components";

const LoginPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.LoginPage })),
);
const HomePage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.HomePage })),
);
const MatterListPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.MatterListPage })),
);
const MatterDetailPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.MatterDetailPage })),
);
const ClientListPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.ClientListPage })),
);
const ClientDetailPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.ClientDetailPage })),
);
const WorkbenchListPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.WorkbenchListPage })),
);
const WorkbenchDetailPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.WorkbenchDetailPage })),
);
const ComparePage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.ComparePage })),
);
const HistoryPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.HistoryPage })),
);
const ConversationDetailPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.ConversationDetailPage })),
);
const ProjectGroupPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.ProjectGroupPage })),
);
const EmployeesPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.EmployeesPage })),
);
const SettingsPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.SettingsPage })),
);
const ProfilePage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.ProfilePage })),
);
const ResourceCenterPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.ResourceCenterPage })),
);
const KnowledgeBasePage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.KnowledgeBasePage })),
);
const KnowledgeDetailPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.KnowledgeDetailPage })),
);
const PipelinesPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.PipelinesPage })),
);
const PipelineDetailPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.PipelineDetailPage })),
);
const PersonalSpacePage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.PersonalSpacePage })),
);
const DraftNewPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.DraftNewPage })),
);
const CalendarPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.CalendarPage })),
);
const QuickToolsPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.QuickToolsPage })),
);
const RedactWorkbenchPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.RedactWorkbenchPage })),
);
const DraftsInboxPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.DraftsInboxPage })),
);
const DraftWorkbenchPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.DraftWorkbenchPage })),
);
const DueDiligencePage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.DueDiligencePage })),
);
const DueDiligenceWorkbenchPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.DueDiligenceWorkbenchPage })),
);
const TimeEntriesPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.TimeEntriesPage })),
);
const InternalResourcesPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.InternalResourcesPage })),
);
const ExternalResourcesPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.ExternalResourcesPage })),
);
const IpoPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.IpoPage })),
);
const OverseasListingPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.OverseasListingPage })),
);
const HkexDisplayPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.HkexDisplayPage })),
);
const IpoIntermediaryRankingPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.IpoIntermediaryRankingPage })),
);
const VaultHomePage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.VaultHomePage })),
);
const VaultCompanyPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.VaultCompanyPage })),
);
const VaultIssueDetailPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.VaultIssueDetailPage })),
);
const VaultQaPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.VaultQaPage })),
);
const VaultBoardPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.VaultBoardPage })),
);
const HelpPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.HelpPage })),
);
const MeetingCenterPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.MeetingCenterPage })),
);
const ScheduledTasksPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.ScheduledTasksPage })),
);
const AgentRunDetailPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.AgentRunDetailPage })),
);
const ExtractionsPage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.ExtractionsPage })),
);
const PublicSharePage = lazy(() =>
  import("@joint/jerry/pages").then((m) => ({ default: m.PublicSharePage })),
);
const CapabilitiesPanel = lazy(() =>
  import("@joint/jerry/components").then((m) => ({ default: m.CapabilitiesPanel })),
);
const McpServersPanel = lazy(() =>
  import("@joint/jerry/components").then((m) => ({ default: m.McpServersPanel })),
);
const KnowledgePanel = lazy(() =>
  import("@joint/jerry/components").then((m) => ({ default: m.KnowledgePanel })),
);
const PipelineManagementPanel = lazy(() =>
  import("@joint/jerry/components").then((m) => ({ default: m.PipelineManagementPanel })),
);

// Keying the detail page by conversation id forces a remount when navigating
// between conversations, so per-conversation send state and refs (optimistic
// bubbles, auto-send guard, reply-failure notice) never leak across them.
function ConversationDetailRoute() {
  const { id } = useParams<{ id: string }>();
  return <ConversationDetailPage key={id} />;
}

function PageLoader() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        color: "var(--jerry-text-tertiary)",
        fontSize: 14,
      }}
    >
      加载中...
    </div>
  );
}

export function AppRoutes() {
  const [compassCollapsed, setCompassCollapsed] = useState(false);
  const toggleCompass = useCallback(() => setCompassCollapsed((c) => !c), []);

  return (
    <ErrorBoundary>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          {/* Public share — no auth required */}
          <Route path="/s/:token" element={<PublicSharePage />} />

          <Route element={<ProtectedRoute />}>
            {/* Full-screen comparison workspace — host for veri_doc's
                ComparisonWorkspace. Auth required, but no AppLayout chrome so
                the workspace owns the whole viewport. */}
            <Route path="/compare/:comparisonId" element={<ComparePage />} />

            {/* Workbench detail — sidebar-less and top-bar-less shell. The page
                already has its own three-column layout (source info + preview +
                AI review) plus a self-contained detailToolbar; the global sidebar
                and global top bar would only duplicate the chrome and squeeze the
                center pane. Mobile drawer stays available via AppLayout so phone
                users can still navigate. */}
            <Route
              path="/workbench/:id"
              element={
                <AppLayout showCompass={false} showSidebar={false} showTopBar={false}>
                  <WorkbenchDetailPage />
                </AppLayout>
              }
            />

            {/* Draft workbench (起草工作台) — same sidebar-less/top-bar-less
                shell treatment as /workbench/:id: the page owns a three-column
                layout (draft info + editor + AI chat) with its own top bar. */}
            <Route
              path="/drafts/:draftId"
              element={
                <AppLayout showCompass={false} showSidebar={false} showTopBar={false}>
                  <DraftWorkbenchPage />
                </AppLayout>
              }
            />

            {/* Due-diligence workbench (尽职调查工作台) — same shell treatment
                as /drafts/:draftId: the page owns a three-column layout that
                dynamically switches content between collect/research/report
                stages with its own top bar. */}
            <Route
              path="/due-diligence/:projectId"
              element={
                <AppLayout showCompass={false} showSidebar={false} showTopBar={false}>
                  <DueDiligenceWorkbenchPage />
                </AppLayout>
              }
            />

            {/* Home page — compass hidden, sidebar + top bar shown.
                mainScroll="hidden": hero state scrolls inside mainInner, chat
                state owns its own internal scroll (message thread); the outer
                main column must never scroll, otherwise the chat input gets
                pushed off-screen. */}
            <Route
              path="/"
              element={
                <AppLayout showCompass={false} mainScroll="hidden">
                  <HomePage />
                </AppLayout>
              }
            />

            {/* Conversation detail — same chrome as other pages (sidebar + top
                bar) but main column does NOT scroll itself. The page owns a
                fixed header + internally scrolling message thread + fixed
                composer; an outer scroll would push the header or composer out
                of view, which is what this shell prevents. */}
            <Route
              path="/history/:id"
              element={
                <AppLayout showCompass={false} mainScroll="hidden">
                  <ConversationDetailRoute />
                </AppLayout>
              }
            />

            {/* IPO 宝库 AI 问答（期 4）—— 同 /history/:id 的壳处理：页面自带
                固定页头 + 内部滚动的消息流 + 固定输入区，外层 main 列不滚动。 */}
            <Route
              path="/useful-info/vault/qa"
              element={
                <AppLayout showCompass={false} mainScroll="hidden">
                  <VaultQaPage />
                </AppLayout>
              }
            />

            {/* 会议助手（S11 两栏持久布局）—— 同上：左栏会议列表与右栏详情面板
                各自独立滚动，外层 main 列不滚动，否则页头会被顶出视口。 */}
            <Route
              path="/meeting-center"
              element={
                <AppLayout showCompass={false} mainScroll="hidden">
                  <MeetingCenterPage />
                </AppLayout>
              }
            />

            {/* 客户与事项 — 三栏工作台（左客户/中事项/右文档）。mainScroll="hidden"：
                各栏独立滚动，外层 main 列不滚动，否则工具栏和底栏会被挤走。 */}
            <Route
              path="/matters"
              element={
                <AppLayout showCompass={false} mainScroll="hidden">
                  <MatterListPage />
                </AppLayout>
              }
            />

            {/* All other pages without compass */}
            <Route
              path="/*"
              element={
                <AppLayout showCompass={false}>
                  <Routes>
                    <Route path="/matters/:id" element={<MatterDetailPage />} />
                    <Route path="/clients" element={<ClientListPage />} />
                    <Route path="/clients/:id" element={<ClientDetailPage />} />
                    <Route path="/workbench" element={<WorkbenchListPage />} />
                    <Route path="/history" element={<HistoryPage />} />
                    <Route path="/project-groups" element={<ProjectGroupPage />} />
                    <Route
                      path="/employees"
                      element={
                        // US-H01: roster is admin-only (jerry.member:manage);
                        // backend endpoints enforce the same gate.
                        <PermissionRoute permission="jerry.member:manage">
                          <EmployeesPage />
                        </PermissionRoute>
                      }
                    />
                    <Route path="/settings" element={<SettingsPage />} />
                    <Route path="/profile" element={<ProfilePage />} />
                    <Route path="/resources" element={<ResourceCenterPage />}>
                      <Route index element={<Navigate to="capabilities" replace />} />
                      <Route path="capabilities" element={<CapabilitiesPanel />} />
                      <Route path="mcp-servers" element={<McpServersPanel />} />
                      <Route path="knowledge" element={<KnowledgePanel />} />
                      <Route path="pipelines" element={<PipelineManagementPanel />} />
                    </Route>
                    <Route path="/knowledge/:id" element={<KnowledgeDetailPage />} />
                    {/* 入口收敛（ADR 2026-07-09）：知识库并入资源中心学习资料库。
                        重定向保留旧链接可用；详情页 /knowledge/:id 仍在用。 */}
                    <Route
                      path="/knowledge"
                      element={<Navigate to="/resource-center/internal" replace />}
                    />
                    <Route path="/knowledge-legacy" element={<KnowledgeBasePage />} />
                    <Route path="/pipelines" element={<PipelinesPage />} />
                    <Route path="/pipelines/:id" element={<PipelineDetailPage />} />
                    <Route path="/personal-space" element={<PersonalSpacePage />} />
                    <Route path="/time-entries" element={<TimeEntriesPage />} />
                    {/* AI drafting (US-D) — matter-scoped only, no matterless entry
                        (product decision: drafting is always entered from a matter). */}
                    <Route path="/matters/:matterId/draft/new" element={<DraftNewPage />} />
                    <Route path="/matters/:matterId/drafts/:draftId" element={<DraftNewPage />} />
                    <Route path="/calendar" element={<CalendarPage />} />
                    <Route path="/quick-tools" element={<QuickToolsPage />} />
                    <Route path="/quick-tools/redact" element={<RedactWorkbenchPage />} />
                    {/* 草稿箱（跨事项草稿聚合列表）。单草稿工作台 /drafts/:draftId
                        在上方以无侧边栏 shell 单独注册；此处两条路由与事项内一次性
                        起草记录（/matters/:matterId/drafts/:draftId）是不同实体。 */}
                    <Route path="/drafts" element={<DraftsInboxPage />} />
                    <Route path="/due-diligence" element={<DueDiligencePage />} />
                    <Route path="/resource-center/internal" element={<InternalResourcesPage />} />
                    <Route path="/resource-center/external" element={<ExternalResourcesPage />} />
                    <Route path="/useful-info/vault" element={<VaultHomePage />} />
                    <Route path="/useful-info/vault/board/:key" element={<VaultBoardPage />} />
                    <Route path="/useful-info/vault/company/:name" element={<VaultCompanyPage />} />
                    <Route path="/useful-info/vault/issue/:uid" element={<VaultIssueDetailPage />} />
                    <Route path="/useful-info/ipo" element={<IpoPage />} />
                    <Route path="/useful-info/overseas-listing" element={<OverseasListingPage />} />
                    <Route path="/useful-info/hkex" element={<HkexDisplayPage />} />
                    <Route path="/useful-info/ipo-intermediary-ranking" element={<IpoIntermediaryRankingPage />} />
                    <Route path="/help" element={<HelpPage />} />
                    <Route path="/scheduled-tasks" element={<ScheduledTasksPage />} />
                    {/* AI 任务中心：/agent-runs 列表页并入 /scheduled-tasks（整页
                        合并），旧链接重定向；执行详情 /agent-runs/:id 原样保留为
                        执行视图，深链来自 jerry.agent_run 通知（ref_id =
                        agent_run.id）。 */}
                    <Route path="/agent-runs" element={<Navigate to="/scheduled-tasks" replace />} />
                    <Route path="/agent-runs/:id" element={<AgentRunDetailPage />} />
                    <Route path="/extractions" element={<ExtractionsPage />} />
                  </Routes>
                </AppLayout>
              }
            />
          </Route>
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}
